<template>
  <div class="instrument-package-edit">
    <!-- 新建 编辑 器械包 -->
    <p class="page-title">{{`${$route.params.id !== '0' ? `编辑` : `新建`}器械包 ${instrumentset.name ? ` - ${instrumentset.name}` : ''}`}}</p>
    <!-- <el-button class="pull-right" type="primary" plain size="mini" @click.prevent="back()"><i class="el-icon-back"></i>返回上一页</el-button> -->
    <div class="page-card">
      <el-tabs v-model="activeTab">
        <!-- 器械包基本信息 -->
        <el-tab-pane name="basic" :label="`基本信息`" >
          <div class="page-section">
            <el-form :model="instrumentset" :rules="rules" ref="instrumentset" label-width="160px" :inline="true" class="demo-form-inline">
              <!-- 包名称 -->
              <el-form-item :label="`名称`" prop="name">
                  <el-input :placeholder="`请输入`" class="input200" v-model="instrumentset.name" clearable @blur="instrumentsetNameBlur"></el-input>
              </el-form-item>
              <!-- 包类别 -->
              <el-form-item :label="`类别`" prop="type">
                <!-- <el-radio-group @input="switchAutoupdateInstrument()" class="mt10" v-model="instrumentset.type">
                  <el-radio v-for="(p, i) in packageSorts" :label="p.value" :key="i">{{p.name}}</el-radio>
                </el-radio-group> -->
                <el-select v-model="instrumentset.type" class="input200" @change="switchAutoupdateInstrument">
                  <el-option
                    v-for="item in packageSorts"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 拼音 -->
              <el-form-item :label="`拼音`" prop="abc_code">
                <el-input :placeholder="`请输入`" class="input200" v-model="instrumentset.abc_code" clearable ></el-input>
              </el-form-item>
              
              <el-form-item :label="`${group1}`" prop="group1">
                <!-- 请选择 -->
                <el-select class="input200" v-model="instrumentset.group1" clearable :placeholder="`请选择`">
                  <el-option
                    v-for="item in dsinstrumentset_type"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 科室 -->
              <el-form-item 
                :label="`科室`"
                prop="department_id"
                :rules="{
                  required: instrumentset.type==6 && exec[548],
                  message: `请选择`,
                  trigger: 'change' }"
                >
                <!-- 请选择科室 -->
                <el-select
                  class="input200"
                  v-model="instrumentset.department_id"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  :placeholder="`请选择`"
                  @focus="getDepartmentOptions('')"
                  @change="departmentChange"
                  :remote-method="getDepartmentOptions"
                  >
                  <el-option
                    v-for="item in dsinstrumentset_ownership"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 处理方式 -->
              <el-form-item :label="`处理方式`" prop="sterilization_option" :required="exec[434] == 1">
                <!-- 请选择 -->
                <el-select class="input200" v-model="instrumentset.sterilization_option" @change="handleDeadlineChange" clearable :placeholder="`请选择`">
                  <el-option
                    v-for="item in dsinstrumentset_processing_method"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 包装方式 -->
              <el-form-item :label="`包装方式`" prop="pack_option" :required="exec[434] == 1">
                <el-select class="input200" v-model="instrumentset.pack_option" clearable @change="handleDeadlineChange" :placeholder="`请选择`">
                  <el-option
                    v-for="item in dsinstrumentset_pack_method"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 清洗方式 -->
              <el-form-item :label="`清洗方式`" prop="clean_option">
                <el-select class="input200" v-model="instrumentset.clean_option" clearable :placeholder="`请选择`">
                  <el-option
                    v-for="item in dsinstrumentset_clean_method"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="`${group2}`" prop="group2">
                <el-select class="input200" v-model="instrumentset.group2" clearable :placeholder="`请选择`">
                  <el-option
                    v-for="item in dsinstrumentset_pack_spec"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="`${group3}`" prop="group3">
                <el-select class="input200" v-model="instrumentset.group3" clearable :placeholder="`请选择`">
                  <el-option
                    v-for="item in dsinstrumentset_pack_type"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="`${group4}`" prop="group4" :required="exec[434] == 1">
                <el-select class="input200" v-model="instrumentset.group4" clearable :placeholder="`请选择`">
                  <el-option
                    v-for="item in dsinstrumentset_group"
                    :key="item.id"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              
              
              <!-- 灭菌费 -->
              <el-form-item :label="`灭菌费`" prop="sterilization_cost">
                <el-input-number
                  class="input200"
                  v-model="instrumentset.sterilization_cost"
                  :precision="4"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <!-- 清洗费 -->
              <el-form-item :label="`清洗费`" prop="clean_cost">
                <el-input-number
                  class="input200"
                  v-model="instrumentset.clean_cost"
                  :precision="4"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <!-- 检查包装费 -->
              <el-form-item :label="`检查包装费`" prop="pack_cost">
                <el-input-number
                  class="input200"
                  v-model="instrumentset.pack_cost"
                  :precision="4"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <!-- 发放费 -->
              <el-form-item :label="`发放费`" prop="out_cost">
                <el-input-number
                  class="input200"
                  v-model="instrumentset.out_cost"
                  :precision="4"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="" prop="cost">
                <div style="display: inline-block;width: 160px;text-align: right;">
                <el-tooltip style="margin-left: 25px" class="item" effect="dark" placement="top">
                  <!-- 设置收费模式，并做出相关收费说明？ -->
                  <div slot="content">设置收费模式，并做出相关收费说明？</div>
                  <i  class="el-icon-question prompt_i"></i>
                </el-tooltip>
                <!-- 成本金额 -->
                <label class="grayfont" style="margin-right: 10px;">成本金额</label>
                </div>
                <el-input-number
                  class="input200"
                  v-model="instrumentset.cost"
                  :precision="4"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <!-- 结算金额 -->
              <el-form-item :label="`结算金额`" prop="settlement_cost">
                <el-input-number
                  class="input200"
                  v-model="instrumentset.settlement_cost"
                  :precision="4"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <!-- 重量 -->
              <el-form-item :label="`重量`" prop="weight">
                <el-input :placeholder="`请输入`" class="input200" v-model="instrumentset.weight" clearable ><template slot="append">克</template></el-input>
              </el-form-item>
              <!-- 器械件数 -->
              <el-form-item :label="`器械件数`" prop="instrument_num" :required="exec[434] == 1">
                <el-input-number class="p12 input200" v-model="instrumentset.instrument_num" :min="0" label="描述文字"></el-input-number>
              </el-form-item>
              <!-- 耗材件数 -->
              <!-- <el-form-item :label="`耗材件数`" prop="disposable_number">
                <el-input-number class="p12 input200" v-model="instrumentset.disposable_number" :min="0" label="描述文字"></el-input-number>
              </el-form-item> -->
              <!-- 配组件数 -->
              <!-- <el-form-item :label="`配组件数`" prop="group_num">
                <el-input :placeholder="`请输入`" class="input200" v-model="instrumentset.group_num" clearable ></el-input>
              </el-form-item> -->
              <!-- 财产归属科室 -->
              <el-form-item :label="`财产归属科室`" prop="owner_department_id">
                <el-select
                  class="input200"
                  v-model="instrumentset.owner_department_id"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  :placeholder="`请选择`"
                  @focus="getDepartmentOptions('')"
                  :remote-method="getDepartmentOptions"
                  >
                  <el-option
                    v-for="item in dsinstrumentset_ownership"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- 外来器械包类名 -->
              <el-form-item v-if="exec[446] && instrumentset.is_short_term == 2" :label="`外来器械包类名`" prop="foreign_class_name">
                <el-input :placeholder="`请输入`" class="input200" v-model="instrumentset.foreign_class_name" />
              </el-form-item>
              <!-- 其他费用 -->
              <el-form-item :label="`其他费用`" prop="other_cost">
                <el-input-number
                  class="input200"
                  v-model="instrumentset.other_cost"
                  :precision="4"
                  :min="0"
                ></el-input-number>
              </el-form-item>
              <!-- 是否外来器械 -->
              <el-form-item :label="`是否外来器械`" prop="">
                <el-radio-group class="input200" v-model="instrumentset.is_short_term">
                  <!-- 长租 -->
                  <el-radio :label="2">是</el-radio>
                  <!-- 否 -->
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </div>
          <div class="page-section mt10">
            <!-- 上传照片 -->
            <span class="ml10 fontsize15 mr10">照片:</span>
            <el-button class="input150" icon="el-icon-camera" size="mini" type="primary" @click="openUpload('picture')">上传</el-button>
            <div class="upload_img mb10" v-if="instrumentset.image_list && instrumentset.image_list.length > 0">
              <div class="img" v-for="(image, index) in instrumentset.image_list" :key="index">
                <el-image :src="image.url" :preview-src-list="instrumentset.image_list.map(i => i.url)"  />
                <i class="el-icon-error del" @click="delImg(index)"></i>
              </div>
            </div>	
          </div>
        </el-tab-pane>
        <!-- 包刻码 -->
        <el-tab-pane v-if="instrumentset.type === 100" name="code" :label="`包刻码`">
          <el-input-number class="input200 mt10 p12 mr10" v-model="packageNum" :min="1" label="描述文字"></el-input-number>
          <!-- 添加 -->
          <el-button class="mt10 mr10" size="mini" type="primary" @click.prevent="addInnerCode()"><i class="el-icon-plus"></i> 添加</el-button>
          <el-select v-if="exec[240] === 1" class="mt10" v-model="packageSelect"  :placeholder="`请选择`">
            <el-option
              v-for="item in printConfig"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <div class="vux_table pl0 mt10">
              <el-table
                stripe
                border
                :data="instrumentset.code_list"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="#"
                  align="center"
                  width="60">
                </el-table-column>
                <!-- 包编码 -->
                <el-table-column
                  prop="inner_code"
                  :label="`编码`"
                  align="center">
                </el-table-column>
                <!-- 包名 -->
                <el-table-column
                  prop="name"
                  :label="`名称`"
                  align="center">
                  <template slot-scope="scope">
                    <el-input class="input200" v-model="scope.row.name"></el-input>
                  </template>
                </el-table-column>
                <!-- 使用次数 -->
                <el-table-column
                  prop="name"
                  :label="`可使用次数`"
                  align="center">
                  <template slot-scope="scope">
                    <el-input-number :min="0" class="input200" v-model="scope.row.use_limit"></el-input-number>
                  </template>
                </el-table-column>
                <!-- 创建时间 -->
                <el-table-column
                  prop="created_at"
                  :label="`创建时间`"
                  align="center">
                </el-table-column>
                <!-- 备注 -->
                <el-table-column
                  prop="remark"
                  :label="`备注`"
                  align="center">
                  <template slot-scope="scope">
                    <el-input class="input200" v-model="scope.row.remark" :maxlength="100"></el-input>
                  </template>
                </el-table-column>
                <!-- 关联 -->
                <el-table-column
                  prop="created_at"
                  :label="`关联`"
                  align="relation_code">
                  <template slot-scope="scope">
                    <el-input class="input120" v-model="scope.row.relation_code"></el-input>
                  </template>
                </el-table-column>
                <!-- 操作 -->
                <el-table-column
                  prop="created_at"
                  :label="`操作`"
                  align="center">
                  <template slot-scope="scope">
                    <!-- udi绑定 -->
                    <el-tooltip v-if="printConfig" class="item" effect="dark" :content="'UDI'+` 绑定`" placement="top-start">
                      <el-button class="p0 fontsize20" type="text" @click.prevent="openInstrumentDetail(scope.row)"><i class="el-icon-view"></i></el-button>
                    </el-tooltip>
                    <!-- 打印 -->
                    <el-tooltip v-if="printConfig" class="item" effect="dark" :content="`打印`" placement="top-start">
                      <el-button class="p0 fontsize20" type="text" @click.prevent="printTag(scope.row)"><i class="el-icon-printer"></i></el-button>
                    </el-tooltip>
                    <!-- 删除 -->
                    <el-tooltip class="item" effect="dark" :content="`删除`" placement="top-start">
                      <el-button class="p0 fontsize20" type="text" @click.prevent="deleteInnerCode(scope.$index)"><i class="el-icon-delete"></i></el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </el-tab-pane>
        <!-- 器械明细 -->
        <el-tab-pane v-if="instrumentset.fixed !== 1 || instrumentset.is_short_term == 0" name="instrument" :label="`器械明细`">
          <!-- 添加器械 -->
          <span class="fontsize15">器械 (件数: {{totalInstrumentNumber}})</span><br>
          <el-autocomplete
            autocomplete="off"
            class="input200 mr10"
            v-model="instrumentName"
            :fetch-suggestions="getInstruments"
            @select="selectInstrument"
            @input="clearInstrumentValue()"
            :placeholder="`请输入`"
            value-key="fullName"
          ></el-autocomplete>
          <el-input-number class="input200 mt10 p12 mr10" v-model="newInstrumentNum" :min="1"  label="描述文字"></el-input-number>
          <!-- 添加器械 -->
          <el-button class="mt10" size="mini" type="primary" @click.prevent="addInstrument"><i class="el-icon-plus"></i> 添加</el-button>
          <!-- 自动更新 -->
          <el-checkbox class="ml10" v-model="autoupdateInstrument">{{ `自动更新`  }}</el-checkbox>
          <!-- 特殊备注 -->
          <el-checkbox class="ml10" @change="changeMarks" v-model="checkremark">{{ `特殊备注`  }}</el-checkbox>
          <div class="vux_table pl0 mt10">
              <el-table
                id="instrumentList"
                stripe
                border
                :data="instrumentset.instrument_list"
                row-key="id"
                style="width: 100%">
                <el-table-column
                  type="index"
                  label="#"
                  align="center"
                  width="60">
                </el-table-column>
                <!-- 器械名称 -->
                <el-table-column
                  prop="name"
                  :label="`名称`"
                  align="center">
                </el-table-column>
                <!-- 规格 -->
                <el-table-column
                  prop="specification"
                  :label="`规格`"
                  align="center">
                </el-table-column>
                <!-- 件数 -->
                <el-table-column
                  prop="number"
                  align="center"
                  :label="`件数`">
                  <template slot-scope="scope">
                    <el-input-number class="input120" v-model="scope.row.number" :min="1"></el-input-number>
                  </template>
                </el-table-column>
                <!-- 图片 -->
                <el-table-column
                  prop="image"
                  align="center"
                  :label="`图片`">
                  <template slot-scope="scope">
                    <div
                      v-for="(img, index) in scope.row.image"
                      :key="index"
                      class="list-img-pack"
                    >
                      <el-image
                        :src="img.url"
                        :preview-src-list="scope.row.image.map(i => i.url)"
                      >
                      </el-image>
                      <i class="el-icon-error img-del" @click="delInstrumentImg(scope.row, index)"></i>
                    </div>
                  </template>
                </el-table-column>
                <!-- 是否计数 -->
                <el-table-column
                  prop="is_item_num"
                  align="center"
                  :label="`计数`">
                  <template slot-scope="scope">
                    <el-radio-group class="ml10" v-model="scope.row.is_item_num">
                      <!-- 是否 -->
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
                <!-- 是否加粗 -->
                <el-table-column
                  prop="is_bold"
                  align="center"
                  :label="`加粗`">
                  <template slot-scope="scope">
                    <el-radio-group class="ml10" v-model="scope.row.is_bold">
                      <el-radio :label="1">是</el-radio>
                      <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                  </template>
                </el-table-column>
                <!-- 明细小节 -->
                <el-table-column
                  prop="item_group"
                  align="center"
                  :label="`明细`">
                  <template slot-scope="scope">
                    <!-- 请选择 -->
                    <el-select class="input150" v-model="scope.row.item_group" :placeholder="`请输入`">
                      <el-option v-for="item in itemGroups" :key="item.id" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <!-- 操作 -->
                <el-table-column
                  prop=""
                  align="center"
                  :label="`操作`">
                  <template slot-scope="scope">
                    <el-button class="p0 fontsize20" type="text" @click.prevent="removeInstrument('instrument_list', scope.$index)"><i class="el-icon-delete"></i></el-button>
                    <el-button class="p0 fontsize20" type="text" @click.prevent="openUpload('instrument', scope.row)"><i class="el-icon-camera"></i></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
        </el-tab-pane>
        <!-- 修改日志 -->
        <el-tab-pane name="log" :label="`日志`">
          <el-table
            stripe
            border
            :data="instrumentset.change_log"
            style="width: 100%">
            <el-table-column
              type="index"
              label="#"
              align="center"
              width="60">
            </el-table-column>
            <el-table-column
              prop="created_at"
              :label="`时间`"
              align="center">
            </el-table-column>
            <el-table-column
             :label="`人员`"
              prop="change_user"
              align="center">
            </el-table-column>
            <el-table-column
              prop="change_log"
              align="center"
              :label="`内容`">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane name="file" :label="`附件`">
          <el-button @click="openUpload('file')" size="mini" type="primary"><i class="el-icon-upload2">上传</i></el-button>
          <div class="mt10">
            <el-table
              stripe
              border
              :data="instrumentset.file_list"
              style="width: 100%">
              <el-table-column
                type="index"
                label="#"
                align="center"
                width="60">
            </el-table-column>
              <el-table-column
                prop="name"
                :label="`文件名`"
                align="center">
              </el-table-column>
              <el-table-column
                prop="type"
                :label="`类型`"
                align="center">
                <template slot-scope="scope">
                  {{fileTypes.filter(i => i.value === scope.row.type)[0] ? fileTypes.filter(i => i.value === scope.row.type)[0].name : ''}}
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                align="center"
                :label="`操作`">>
                <template slot-scope="scope">
                  <el-button class="p0 fontsize20" type="text" @click.prevent="download(scope.row.url)"><i class="el-icon-download"></i></el-button>
                  <el-button class="p0 fontsize20" type="text" @click.prevent="deleteFile(scope.$index)"><i class="el-icon-delete"></i></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="mt10">
        <el-button v-if="btnauth['/basic/instrument-package/index'].includes('package_preserve_button')" size="small" type="primary" @click="save()">保存</el-button>
        <!-- 另存为新包 -->
        <el-button size="small" type="primary" @click="save(true)" v-if="pageId && btnauth['/basic/instrument-package/index'].includes('package_preserve_button')">另存为新包</el-button>
        <el-button size="small" @click="back()">取消</el-button>
        <!-- 打印 -->
        <!-- <el-button v-if="pageId" size="small" type="primary" @click="print()">打印</el-button> -->
      </div>
    </div>
    <PictureSelect ref="pictureSelect" @complete="getPicture" />
    <UploadFile ref="uploadFile" @complete="getFile" />
    <InstrumentDetail ref="InstrumentDetail" @close="InstrumentDetailClose" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PictureSelect from '@/components/common/PictureSelect/index.vue'
import UploadFile from '@/components/common/UploadFile.vue'
import InstrumentDetail from './components/InstrumentDetail.vue'
import { instrumentPackageEdit, instrumentPackage, departmentOptions, instrumentOptions, disposalOptions, plantOptions, getWareHouseList, getPackageDetail, batchPackageInfo, instrumentList, disposablesList,costTypeList, vendorOptions, deadlineConfiguration, instrumentBindImg, handOverCenterConifg} from '@/api.js'
export default {
  name: 'InstrumentPackageEdit',
  components: {
    PictureSelect, UploadFile, InstrumentDetail
  },
  computed: {
    ...mapGetters(['exec', 'system', 'btnauth', 'user']),
    totalNumber: function () {
      let total = 0;
      this.instrumentset.disposable_list.forEach(item => {
        // console.log(item.number)
        total += item.number;
      });
      return total;
    },
    totalInstrumentNumber: function () {
      let total = 0;
      this.instrumentset.instrument_list.forEach(item => {
        // console.log(item.number)
        total += item.number;
      });
      return total;
    }
  },
  watch: {
    // 'instrumentset.name'(newValue) {
    //   if (this.instrumentset.code_list && newValue) {
    //     this.instrumentset.code_list.forEach(i => {
    //       const spliterIndex = i.name.lastIndexOf('-')
    //       // 如果包名有修改则用修改的
    //       if (spliterIndex > 0) {
    //         const nameCode = i.name.substring(0, spliterIndex)
    //         i.name = `${newValue === nameCode? newValue : nameCode}-${i.name.substr(spliterIndex + 1, i.name.length)}`
    //       }
    //     })
    //   }
    // },
    // 'instrumentset.instrument_list': {
    //   deep: true,
    //   handler(newValue) {
    //     let num = 0
    //     newValue.forEach(i => {
    //       if (i.is_item_num == 1) {
    //         num += i.number
    //       }
    //     })
    //     if (newValue.length > 0) {
    //       this.instrumentset.instrument_num = num
    //     }
    //   } 
    // },
    'instrumentset.has_plant': {
      deep: true,
      handler(newValue) {
        if (newValue > 0) {
          this.$set(this.instrumentset, 'is_biotest', 1)
          this.bioLock = true
        } else {
          this.bioLock = false
        }
      } 
    }
  },
  data() {
    return {
      pageId: 0,
      activeTab: 'basic', // basic, code, fixed, instrument, material, log, file
      rules: {
        name: [
          {
            required: true, 
            trigger: 'blur',
            validator: (rule, value, cb) => {
              if (!value || value && !value.trim()) {
                cb(`名称不能为空`)
              } else {
                cb()
              }
            }
          },
        ],
        type: [
          { required: true, message: `类型不能为空`, trigger: 'change' },
        ]
      },
      bioLock: false,
      needPrintDisabled: false,
      instrumentset: {
        type: 2,
        has_plant: 0,
        // need_print: 1,
        // bundle_print: 0,
        // update_number: 1,
        sundries: 0,
        auto_deadline: 1,
        is_out_sure: 0,
        instrument_list: [],
        auto_out:-1,
        apply_print_order: 0,
        disposable_list: [],
        special_remark:'',
        is_special_remark: 0,
        is_short_term: 0
      },
      dsinstrumentset_type: [],
      dsinstrumentset_ownership: [],
      dsinstrumentset_processing_method: [],
      cost_type_method:[],
      dsinstrumentset_clean_method: [],
      dsinstrumentset_pack_method: [],
      dsinstrumentset_pack_spec: [],
      dsinstrumentset_pack_type: [],
      dsinstrumentset_group: [],
      group5_group:[],
      group6_group:[],
      group7_group:[],
      itemGroups: [],
      packageSorts: [],
      tagSizes: [],
      processOptions: [],
      wareHouseList: [],
      instrumentsetCode: [],
      group1: '',
      group2: '',
      group3: '',
      group4: '',
      group5: '',
      group6: '',
      group7: '',
      packageNum: 1,
      instrumentName: '',
      instrumentValue: '',
      newInstrumentNum: '',
      disposalName: '',
      disposalValue: '',
      newDisposalNum: '',
      instrumentsetFile: [],
      disposals: [],
      instruments: [],
      disposalInstruments: [],
      outerInstrumentset: {
        fixed: [], // 固定明细
        plant_other: [
          {
            instrument_type: 5,
            name: ''
          }
        ], // 其他植入物
        other: [
          {
            instrument_type: 6,
            name: ''
          }
        ] // 其他非植入物
      },
      fixedTypes: [7],
      fileTypes: [],
      plantOptions: [],
      printConfig: undefined,
      autoupdateInstrument: false,
      checkremark:false,
      autoupdateInstrumentTypes: [],
      printLabel: 0,
      center_id: 0,
      packageSelect: '',
      vendorList: [],
      deadlineObject: {},
      editInstrument: null,
      uploadType: '',
      handOverConfig: [],
    }
  },
  async created() {
    const { id } = this.$route.params
    this.pageId = Number(id)
    this.initCenter()
    await Promise.all([this.getDicts(), this.getDepartmentOptions(), this.getInstrumentOptions()])
    if (this.pageId) {
      await this.getDetail()
    } else {
      this.initNew()
      await this.getDealine()
    }
    this.listenScan()
  },
  mounted() {
    this.initialSortable()
    // this.getTypeCostList()
    this.initRules()
  },
  methods: {
    listenScan() {
      // 监听扫码
      this.$scan(document, {
        onScan: (code) => {
          if (code) {
            this.checkCodeAndAdd(code)
          }
        }
      })
    },
    initCenter() {
      if (this.pageId) return
      
      const { department_center } = this.user
      const { id, name } = department_center
      this.insCenter = {
        id, name
      }

      this.$set(this.instrumentset, 'ins_center_id', id)
    },
    async checkCodeAndAdd(code) {
      // 扫码处理
      const { InstrumentDetail } = this.$refs
      const { id } = await this.$utils.getCode(code)
      if (InstrumentDetail && InstrumentDetail.show) {
        let codes = [code]
        if (id === 'td001') {
          codes = code.substring(1, code.length - 1).split('$').filter(i => !!i)
        }

        const checkStatus = await InstrumentDetail.checkUdi(codes)
        if (checkStatus) {
          InstrumentDetail.bindUdi(codes)
        }
      }
    },
    initNew() {
      // 初始化新建
      this.$set(this.instrumentset, 'department_id', this.user.department_data.id)
    },
    initRules() {
      // 初始化必填项
      if (this.exec[434]) {
        this.rules['group4'] = { required: true, message: `请选择`, trigger: 'change' }
        this.rules['sterilization_option'] = { required: true, message: `请选择`, trigger: 'change' }
        this.rules['pack_option'] = { required: true, message: `请选择`, trigger: 'change' }
        this.rules['deadline'] = { required: true, message: `请输入`, trigger: 'blur' }
        // const greaterthan = `器械件数要大于0`
        // this.rules['instrument_num'] = { required: true, validator: function(rule, value, cb) { if (value >= 0) { cb() } else {cb(greaterthan)} }, trigger: 'blur' }
      }
    },
    switchAutoupdateInstrument() {
      const { type } = this.instrumentset

      this.autoupdateInstrument = this.exec[111] === 1 && this.autoupdateInstrumentTypes.includes(type)
      if (type === 3 || type === 6) {
        this.instrumentset.is_out_sure = 0
      }
      if (type === 1) {
        this.instrumentset.sundries = 0
      }

      // 基础数据维护为代消包时，绑定科室不能选择自己供应室
      if(type == 6 && this.user.department_data.type == this.instrumentset.department_id){
        let index = this.dsinstrumentset_ownership.findIndex(item=>item.type != this.user.department_data.type)
        this.instrumentset.department_id = this.dsinstrumentset_ownership[index].id
      }
      this.$refs.instrumentset.clearValidate()
    },
    initialSortable() {
      const tbody1 = document.querySelector('#instrumentList .el-table__body-wrapper tbody')
      // const tbody2 = document.querySelector('#disposalList .el-table__body-wrapper tbody')
      const _this = this
      this.$sort.create(tbody1, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.instrumentset.instrument_list.splice(oldIndex, 1)[0]
          _this.instrumentset.instrument_list.splice(newIndex, 0, currRow)
        }
      });
      // this.$sort.create(tbody2, {
      //   onEnd({ newIndex, oldIndex }) {
      //     const currRow = _this.instrumentset.disposable_list.splice(oldIndex, 1)[0]
      //     _this.instrumentset.disposable_list.splice(newIndex, 0, currRow)
      //   }
      // });
    },
    getTypeCostList(){
      // 获取列表数据
      const url = costTypeList
      const queryParams = {
        is_all: 1,
      }

      this.$request('get', url, queryParams)
      .then((res) => {
        if (res) {
          this.cost_type_method = res
        }
      })
    },
    getVendors(query, cb) {
      const params = {
        name: query || '',
        type: 2
      }
      this.$request('get', vendorOptions, params)
      .then((res) => {
        this.vendorList = res
        if (cb) {
            cb(res)
          }
      })
    },
    getOverConfig() {
      this.$request('get', handOverCenterConifg).then((res) => {
        this.handOverConfig = res
      })
    },
    getDicts() {
      return this.$utils.getDict([338, 15, 8, 314, 5, 150, 70, 200, 160, 316, 317, 318, 319, 322, 238, 236, 354, 350, 475,499,500,501,509,510,511]).then(res => {
        if (res) {
          this.dsinstrumentset_processing_method = res[338]
          this.dsinstrumentset_clean_method = res[15]
          this.dsinstrumentset_type = res[8]
          this.packageSorts = res[314]
          this.dsinstrumentset_pack_method = res[5]
          this.dsinstrumentset_pack_spec = res[150]
          this.tagSizes = res[200]
          this.dsinstrumentset_pack_type = res[160]
          this.dsinstrumentset_group = res[70]
          this.group5_group = res[509]
          this.group6_group = res[510]
          this.group7_group = res[511]
          this.fileTypes = res[322]
          this.itemGroups = res[236]
          this.processOptions = res[354]
          this.group1 = res[316][0]['name']
          this.group2 = res[317][0]['name']
          this.group3 = res[318][0]['name']
          this.group4 = res[319][0]['name']
          // this.group5 = res[499][0]['name']
          // this.group6 = res[500][0]['name']
          // this.group7 = res[501][0]['name']
          if (this.exec[240] === 1) {
            this.printConfig = res[238]
            this.packageSelect = res[238][0].value
          } else {
            this.printConfig = res[238][0]
          }
          this.printLabel = res[350][0] ? res[350][0]['value'] : 0,
          this.autoupdateInstrumentTypes = (res[475] || []).map(i => i.value)
        }
      })
    },
    async getDealine() {
      const query = {}
      if (this.instrumentset.center_id != this.user.department_center.id) {
        query.ins_center_id = this.instrumentset.ins_center_id
      }
      const res =  await this.$request('get', deadlineConfiguration, query)
      this.deadlineObject = res
    },
    async getInstruments(name = '', cb) {
      const query = {
        name,
        center_id:this.user.department_data.center_id
      }
      return this.$request('get', instrumentOptions, query)
      .then((res) => {
        if (res) {
          res.forEach(i => {
            i.fullName = `${i.name}${i.specification ? `-${i.specification}` : ''}${i.brand ? `-${i.brand}` : ''}`
          })

          this.instruments = res
          if (cb) {
            cb(res)
          }
        }
      })
    },
    batchPrintChange() {
      //  捆绑打印和标签打印联动
      const { bundle_print } = this.instrumentset
      if (bundle_print == 1) {
        this.needPrintDisabled = true
        this.$set(this.instrumentset, 'need_print', 0)
      } else if (bundle_print == 0) {
        this.needPrintDisabled = false
        this.$set(this.instrumentset, 'need_print', 1)
      }
    },
    selectInstrument(item) {
      // 选择器械
      this.instrumentValue = item.id
    },
    selectDisposalOptions(item) {
      // 选择耗材
      this.disposalValue = item.id
    },
    clearInstrumentValue() {
      this.instrumentValue = ''
    },
    clearDisposalValue() {
      this.disposalValue = ''
    },
    createInstrument() {
      // 新建器械
      const params = {
        name: this.instrumentName,
        standard_name: this.instrumentName
      }

      return this.$request('post', instrumentList, params)
      .then(res => res)
    },
    createDisposables() {
      // 新建耗材
      const params = {
        name: this.disposalName,
        standard_name: this.disposalName,
      }

      return this.$request('post', disposablesList, params)
      .then(res => res)
    },
    openInstrumentDetail(item) {
      // 绑定udi
      const { inner_code } = item

      this.$refs.InstrumentDetail.open(inner_code)
    },
    InstrumentDetailClose() {
      // this.getDetail()
    },
    async printTag(item) {
      // 打印标签
      const code = item.inner_code
      const instrumentset = await this.getInstrumentSetDetail(code)
      const printData = {}
      printData.instrumentset = instrumentset
      printData.instrumentset.codeSrc = this.$utils.generateCode(code, 'datamatrix')
      printData.instrumentset.barcode = this.$utils.generateCode(code, 'code128')
      printData.instrumentset.code = code
      if (this.exec[240] === 1) {
        printData.code_print_template = this.packageSelect
      } else {
        printData.code_print_template = this.printConfig.value
      }

      this.$utils.print(printData)
    },
    getInstrumentSetDetail(id) {
      // 获取器械包详情
      const url = getPackageDetail.replace('{id}', id)
      return this.$request('get', url).then((res) => {
        return res
      })
    },
    asyncMin(item) {
      if (this.exec[124] && item.number_prev > item.number) {
        this.$set(item, 'number', item.number_prev)
      }
    },
    getDepartmentOptions(search) {
      return this.$request('get', departmentOptions, { with_center: 0, with_deleted: 0, name: search || '' })
      .then((res) => {
        if (res) {
          this.dsinstrumentset_ownership = res
          this.center_id = res[0].center_id
          if(this.instrumentset.type == 6){
            this.dsinstrumentset_ownership.forEach(obj => {
              if (obj.type == this.user.department_data.type) {
                obj.disabled = true;
              }else{
                obj.disabled = false;
              }
            });
          }
        }
      })
    },
    departmentChange(id) {
      if (this.instrumentset.department_id === '' || this.instrumentset.department_id === this.center_id) {
        this.instrumentset.auto_out = 0
      }
      // this.getWareHouseList(id)
    },
    getWareHouseList(id) {
      // 获取无菌库列表
      const query = {
        department_id: id,
        type: 2
      }
      this.$request('get', getWareHouseList, query)
      .then((res) => {
        if (res) {
          this.wareHouseList = res
        }
      })
    },
    getInstrumentOptions() {
      return this.$request('get', instrumentOptions, {})
      .then((res) => {
        if (res) {
          this.instruments = res
        }
      })
    },
    async getDisposalOptions(name = '', cb) {
      const query = {
        name,
        center_id:this.user.department_data.center_id
      }
      return this.$request('get', disposalOptions, query )
      .then((res) => {
        if (res) {
          res.forEach(i => {
            i.fullName = `${i.name}${i.specification ? `-${i.specification}` : ''}`
          })

          this.disposals = res
          if (cb) {
            cb(res)
          }
        }
      })
    },
    deleteInnerCode(index) {
      this.instrumentset.code_list.splice(index, 1)
    },
    back() {
      this.$router.back()
    },
    print() {
      // 打印清单
      const { id, code_list } = this.instrumentset
      const inner_code = code_list ? (code_list[0] || {})['inner_code'] : undefined
      const ids = [{ instrumentset_id: id, inner_code }]

      const params = {
        type: 3,
        instrumentset_id: ids
      }

      this.$request('post', batchPackageInfo, params)
      .then((res) => {
        if (res) {
          res.forEach((item) => {
            if (item.inner_code) {
              item.img = this.$utils.generateCode(item.inner_code)
            }

            if (item.clean_basket_code) {
              item.basketCodeImg = this.$utils.generateCode(item.clean_basket_code)
            }

            item.printTime = this.$moment(this.system.time).format('yyyy-MM-DD HH:mm:ss')
          })

          const query ={
            type: 1,
            labelType: this.printLabel,
            data: res,
            exec: this.exec,
            user: this.user
          }

          this.$utils.print(query, 'inventory')
        }
      })
    },
    async getDetail() {
      // 获取详情
      const url = instrumentPackageEdit.replace('{id}', this.pageId)
      const res = await this.$request('get', url, {})
      if (res) {
        this.instrumentset = res
        // if (res.department_id) {
        //   this.getWareHouseList(res.department_id)
        // }
        this.instrumentset.file = this.instrumentset.file_list.map(i => i.id)
        this.instrumentset.image = this.instrumentset.image_list.map(i => i.id)
        this.instrumentset.group1 = this.instrumentset.group1 || ''
        this.instrumentset.group2 = this.instrumentset.group2 || ''
        this.instrumentset.group3 = this.instrumentset.group3 || ''
        this.instrumentset.group4 = this.instrumentset.group4 || ''
        this.instrumentset.node_group3 = this.instrumentset.node_group3 || ''
        this.instrumentset.node_group4 = this.instrumentset.node_group4 || ''
        this.instrumentset.node_group5 = this.instrumentset.node_group5 || ''
        this.instrumentset.department_id = this.instrumentset.department_id || ''
        this.instrumentset.sterilization_option = this.instrumentset.sterilization_option || ''
        this.instrumentset.clean_option = this.instrumentset.clean_option || ''
        this.instrumentset.pack_option = this.instrumentset.pack_option || ''
        this.instrumentset.tag_option = this.instrumentset.tag_option || ''
        this.instrumentset.alert_stock = this.instrumentset.alert_stock || ''
        this.instrumentset.third_party_code = this.instrumentset.third_party_code || ''
        this.instrumentset.address_code = this.instrumentset.address_code || ''
        this.instrumentset.clean_cost = this.instrumentset.clean_cost || ''
        this.instrumentset.sterilization_cost = this.instrumentset.sterilization_cost || ''

        this.$set(this.instrumentset, 'apply_print_order', res.instrumentset_info ? res.instrumentset_info.apply_print_order : 0)

        if(this.instrumentset.is_special_remark === 1){
          this.checkremark = true
        }
        
        // if (this.instrumentset.ins_center_id) {
        //   this.$refs.centerSelect.setCenter({ id: this.instrumentset.ins_center_id})
        // }

        await this.getDealine()
        this.$nextTick(() => {
          this.matchOuterInstrumentset(res.plant_list)
          this.switchAutoupdateInstrument()
          this.handleDeadlineChange('detail')
        })
      }
    },
    matchOuterInstrumentset(list) {
      // 编辑时将数据对应匹配到外来数据模型中
      this.outerInstrumentset.plant_other = [
        {
          instrument_type: 5,
          name: ''
        }
      ]
      this.outerInstrumentset.other = [
        {
          instrument_type: 6,
          name: ''
        }
      ]
      list.forEach((i) => {
        this.outerInstrumentset.fixed.forEach(p => {
          if (i.id === p.instrument_id) {
            p.number = i.number
            p.number_prev = i.number_prev
            p.instrument_id = i.id
            p.is_plant = i.is_plant
          }
        })

        if (i.instrument_type === 5) {
          this.outerInstrumentset.plant_other.push(i)
        }
        
        if (i.instrument_type === 6) {
          this.outerInstrumentset.other.push(i)
        }
      })
      
      // 当植入物和非植入物中有编辑数据时，将data中预留的两个元素删除
      if (this.outerInstrumentset.plant_other.length > 1) {
        this.outerInstrumentset.plant_other.shift()
      }

      if (this.outerInstrumentset.other.length > 1) {
        this.outerInstrumentset.other.shift()
      }
    },
    selectPlant(item) {
      const { id, show_number } = this.plantOptions.filter(i => i.name === item.name && i.instrument_type === item.instrument_type)[0] || {}

      if (id) {
        this.$set(item, 'instrument_id', id)
        this.$set(item, 'show_number', show_number || 0)
      }
    },
    inputPlant(item) {
      this.$set(item, 'instrument_id', '')
      this.$set(item, 'show_number', 0)
    },    
    filterPlant(query, cb) {
      const otherPlant = this.plantOptions.filter(i => i.instrument_type === 6).filter(i => i.name.includes(query))
      
      cb(otherPlant)
    },
    filterOtherPlant(query, cb) {
      const otherPlant = this.plantOptions.filter(i => i.instrument_type === 5).filter(i => i.name.includes(query))
      
      cb(otherPlant)
    },
    delImg(index) {
      this.instrumentset.image_list.splice(index, 1)
    },
    openUpload(type, item = null) {
      this.uploadType = type
      if (type === 'picture') {
        this.$refs.pictureSelect.show()
      } else if (type === 'file') {
        this.$refs.uploadFile.show(this.fileTypes)
      } else if (type === 'instrument') {
        if (item) {
          this.editInstrument = item
          this.$refs.pictureSelect.show()
        }
      }
    },
    getPicture(pictures) {
      // 获取图片列表
      const list = pictures.map(i => {return { id: i.fileId, url: i.fileUrl}})
      if (this.uploadType === 'instrument') {
        const { image } = this.editInstrument
        const images = (image || []).concat(list)
        this.$set(this.editInstrument, 'image', images)

        this.$nextTick(() => {
          const image = this.editInstrument.image.map(i => i.id)

          this.saveInstrument(this.editInstrument, { image })
        })
      } else if (this.uploadType === 'picture') {
        const images = (this.instrumentset.image_list || []).concat(list)
        this.$set(this.instrumentset, 'image_list', images)
      }
    },
    getFile(file) {
      // 接收文件
      const files = this.instrumentset.file_list || []
      files.push({
        id: file.fileId,
        url: file.fileUrl,
        name: file.name,
        type: file.type
      })
      this.$set(this.instrumentset, 'file_list', files)
    },
    deleteFile(index) {
      // 删除文件
      this.instrumentset.file_list.splice(index, 1)
    },
    download(url) {
      // 预览文件
      window.open(url, '_blank')
    },
    addInnerCode() {
      // 添加包刻码
      if (!this.instrumentset.name) {
        // 请先输入包名
        this.$message.error(`请先输入器械包`)
        return
      }
      const length = this.packageNum
      const codes = this.instrumentset.code_list || []
      for (let i = 0; i < length; i++) {
        const item = {
          name: `${this.instrumentset.name}-${codes.length + 1}`
        }
        
        codes.push(item)
      }

      this.$set(this.instrumentset, 'code_list', codes)
    },
    async addInstrument() {
      // 添加包器械
      const key = this.instrumentValue
      if (this.instrumentset.instrument_list && this.instrumentset.instrument_list.filter(i => i.id === key).length > 0) {
        // 该器械已经存在列表中，请勿重复添加
        this.$message.error(`该物品已经存在列表中，请勿重复添加`)
        return
      }

      if (this.instrumentName && !this.instrumentValue) {
        const confirmed = await this.$utils.confirm({msg: `该物品不存在系统中，是否新建`})

        if (confirmed) {
          const id =  await this.createInstrument()
          if (id) {
            this.instrumentValue = id
            await this.getInstruments()

            this.addInstrument()
            return
          }
        }
        
        return
      }

      const item = this.instruments.filter(i => i.id === key)[0]
      if (!item) {
        this.$message.error(`请输入器械`)
        return
      }

      const instrument = Object.assign({}, {number: this.newInstrumentNum, is_bold: 0, is_item_num: 1}, item)
      const list = this.instrumentset.instrument_list || []
      list.push(instrument)
      
      this.$set(this.instrumentset, 'instrument_list', list)
      this.instrumentName = ''
      this.instrumentValue = ''
      this.newInstrumentNum = 1
    },
    async addDisposal() {
      // 添加包耗材
      const key = this.disposalValue
      if (this.instrumentset.disposable_list && this.instrumentset.disposable_list.filter(i => i.id === key).length > 0) {
        this.$message.error(`该物品已经存在列表中，请勿重复添加`)
        return
      }

      if (this.disposalName && !this.disposalValue) {
        const confirmed = await this.$utils.confirm({msg: `该物品不存在系统中，是否新建`})
        if (confirmed) {
          const id = await this.createDisposables()

          if (id) {
            this.disposalValue = id
            await this.getDisposalOptions()

            this.addDisposal()
            return
          }
        }

        return
      }

      const item = this.disposals.filter(i => i.id === key)[0]
      if (!item) {
        this.$message.error(`请输入耗材`)
        return
      }
      const disposal = Object.assign({}, {number: this.newDisposalNum, is_bold: 0, is_item_num: 1}, item)
      const list = this.instrumentset.disposable_list || []
      list.push(disposal)

      this.$set(this.instrumentset, 'disposable_list', list)
      this.disposalValue = ''
      this.disposalName = ''
      this.newDisposalNum = 1
    },
    removeInstrument(type, index) {
      // 移除包刻码、包耗材
      this.instrumentset[type].splice(index, 1)
    },
    handleInstrument() {
      // 将器械、耗材、固定明细整理为一个数组
      const instruments = []
      if (this.instrumentset.fixed === 1 && this.instrumentset.is_short_term > 0) {
        // 固定明细
        this.outerInstrumentset.fixed.forEach((i) => {
          if (i.number || i.number_prev) {
            const item = {
              name: i.name,
              instrument_type: i.instrument_type,
              type: 2,
              is_plant: i.is_plant
            }

            if (i.show_number === 0) {
              i.number = 0
            }

            item.number_prev = i.number_prev

            // 124配置开启时，拆卸后不小于拆卸前
            if (this.exec[124] && i.number < i.number_prev) {
              i.number = i.number_prev
            }

            item.number = i.number

            if (i.instrument_id) {
              item.instrument_id = i.instrument_id
            }

            instruments.push(item)
          }
        })

        this.outerInstrumentset.plant_other.forEach(i => {
          this.handlePlantInstrument(i, instruments)
        })

        this.outerInstrumentset.other.forEach(i => {
          this.handlePlantInstrument(i, instruments)
        })
      } else {
        // 包器械
        if (this.instrumentset.instrument_list) {
          this.instrumentset.instrument_list.forEach(i => {
            instruments.push({
              instrument_id: i.id,
              number: i.number,
              is_bold: i.is_bold,
              is_item_num: i.is_item_num,
              item_group: i.item_group,
              type: 0
            })
          })
        }

        if (this.instrumentset.disposable_list) {
          this.instrumentset.disposable_list.forEach(i => {
            instruments.push({
              instrument_id: i.id,
              number: i.number,
              is_bold: i.is_bold,
              is_item_num: i.is_item_num,
              item_group: i.item_group,
              type: 1
            })
          })
        }
      }

      return instruments
    },
    handlePlantInstrument(i, instruments) {
      // 处理器械数据
      const item = {
        name: i.name,
        instrument_type: i.instrument_type,
        type: 2,
        is_plant: i.is_plant
      }

      if (i.instrument_id) {
        item.instrument_id = i.instrument_id
      }

      if (i.show_number === 0) {
        i.number = 0
      }

      item.number_prev = i.number_prev

      // 124配置开启时，拆卸后不小于拆卸前
      if (this.exec[124] && i.number < i.number_prev) {
        i.number = i.number_prev
      }

      item.number = i.number

      if (item.name && (item.number || item.number_prev)) {
        instruments.push(item)
      }
    },
    save(saveAs = false) {
      // 保存信息, 需要注意包类别在不同的情况下提交内容不同
      this.$refs.instrumentset.validate(async (valid) => {
        if (!valid) {
          this.$message.error(`请填写必填项`)
          this.activeTab = 'basic'
        } else {
          const { pageId } = this
          const url = pageId && !saveAs ? instrumentPackageEdit.replace('{id}', pageId) : instrumentPackage
          if (this.instrumentset.file_list) {
            this.instrumentset.file = this.instrumentset.file_list.map(i => i.id)
          }
          if (this.instrumentset.image_list) {
            this.instrumentset.image = this.instrumentset.image_list.map(i => i.id)
          }
          if (this.instrumentset.code_list) {
            this.instrumentset.code = this.instrumentset.code_list.map(i => {if (i.id) {return {id: i.id, name: i.name, remark: i.remark, relation_code: i.relation_code, use_limit: i.use_limit}} else {return {name: i.name, remark: i.remark, relation_code: i.relation_code, use_limit: i.use_limit}}})
          }

          this.instrumentset.department_id = this.instrumentset.department_id || 0

          this.instrumentset.instrument = this.handleInstrument()

          if (this.autoupdateInstrument) {
            let num = 0;
            (this.instrumentset.instrument_list || []).forEach(i => {
              if (i.is_item_num == 1) {
                num += i.number
              }
            })
            this.instrumentset.instrument_num = num
          }

          if (this.exec[384]) {
            let sum = 0;
            (this.instrumentset.disposable_list || []).forEach(i => {
              if (i.is_item_num == 1) {
                sum += i.number
              }
            })
            this.instrumentset.disposable_number = sum
          }

          // 数据处理(将data中instrumentset拷贝一份用于提交)
          const instrumentset = JSON.parse(JSON.stringify(this.instrumentset))
          for (const key in instrumentset) {
            if (Object.hasOwnProperty.call(instrumentset, key)) {
              const value = instrumentset[key];
              if (value === 0 || value === '') {
                delete instrumentset[key]
              }
            }
          }
          if(instrumentset.auto_out == undefined){
            instrumentset.auto_out = 0
          }
          
          instrumentset.is_special_remark  = this.checkremark ? 1: 0
          if(instrumentset.instrument_list.length === 0){
            instrumentset.is_special_remark = 0
            instrumentset.special_remark = ''
          }
          const res = await this.$request('post', url, instrumentset)
          if (res !== null && `${res}`) {
            this.$message.success(`${pageId ? `编辑` : `新建`} 成功`)
            if (pageId) {
              this.getDetail()
            } else {
              this.$router.replace(`/basic/instrument-package/edit/${res}`)
              this.pageId = Number(res)
            }
            // this.back()
          }
        }
      })
    },
    addOuterPlant(type) {
      // 添加外来植入物
      const item = {
        instrument_type: type,
        name: '',
        number: 0,
        number_prev: 0
      }
      if (type === 5) {
        this.outerInstrumentset.plant_other.push(item)
      } else if (type === 6) {
        this.outerInstrumentset.other.push(item)
      }
    },
    removeOuterPlant(type, index) {
      // 移除外来植入物
      if (type === 5) {
        this.outerInstrumentset.plant_other.splice(index, 1)
      } else if (type === 6) {
        this.outerInstrumentset.other.splice(index, 1)
      }
    },
    // 通过组装获得有效期对应的key
    deadlineMethod(handle, pack) {
      let deadlineStr = ''
      if (this.system.time) {
        deadlineStr = handle + '_' + pack + '_' + this.$moment(this.system.time).format('M')
      } else {
        return this.deadlineMethod(handle, pack)
        // setTimeout(() => {
        //   this.deadlineMethod(handle, pack)
        // }, 200)
      }
      
      if (this.deadlineObject.config[deadlineStr]) {
        return this.deadlineObject.config[deadlineStr]
      } else {
        return this.deadlineObject.default
      }
    },
    handleDeadlineChange(type='') {
      if (this.instrumentset.auto_deadline === 1 && type !== 'detail') {
        this.instrumentset.deadline  = this.deadlineMethod(this.instrumentset.sterilization_option? this.instrumentset.sterilization_option : 0, this.instrumentset.pack_option? this.instrumentset.pack_option : 0)
      }
    },
    instrumentsetNameBlur() {
      if (this.instrumentset.code_list && this.instrumentset.name) {
        this.instrumentset.code_list.forEach(i => {
          const spliterIndex = i.name.lastIndexOf('-')
          if (spliterIndex > 0) {
            i.name = `${this.instrumentset.name}-${i.name.substr(spliterIndex + 1, i.name.length)}`
          } else {
            i.name = `${this.instrumentset.name}`
          }
        })
      }
    },
    async delInstrumentImg(item, index) {
      // 删除器械图片
      const confirm = await this.$utils.confirm({ msg: `确认删除吗?` })
      if (!confirm) return

      item.image.splice(index, 1)
      const image = item.image.map(i => i.id)
      this.saveInstrument(item, { image })
    },
    saveInstrument(item, data) {
      // 保存器械，传入包含需要更新的字段的数据对象
      const { id } = item
      const { image } = data
      const params = {
        instrument_id: id,
        file_ids: image
      }
      
      this.$request('post', instrumentBindImg, params)
      .then(res => {
        if (res) {
          this.$message.success(`成功`)
        }
      })
    },
    changeMarks(){
      this.instrumentset.special_remark = ''
      if(this.instrumentset.instrument_list.length == 0){
        this.$message.warning(`器械明细不能为空`)
        this.checkremark = false
      }else{
        if(this.checkremark){
          const data = this.instrumentset.instrument_list
          data.forEach(item => {
            this.instrumentset.special_remark += `${item.name}*${item.number}\n`;
          });
          // console.log(this.instrumentset.special_remark)
        }
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>
  .instrument-package-edit {
    position: relative;
    .prompt_i {
      font-size: 20px;
      color: orange;
      padding: 5px;
      cursor: pointer;
    }
    .upload_img {
      display: flex;
      .img {
        width: 60px;
        height: 60px;
        position: relative;
        margin: 10px;
        img {
          width: 100%;
          height: 100%;
        }
        .del {
          position: absolute;
          right: 3px;
          top: -6px;
          color: gray;
          width: 6px;
          height: 6px;
          cursor: pointer;
        }
      }
    }
    .labelInput {
      width: 90px;
      display: inline-block;
      line-height: 20px;
    }
  }
</style>